// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomAppState } from "@werner/App/Store/Reducers";
import { parseBoolean } from "@werner/XDL/Utilities";

export const selectHasOutOfStockItems = (state: CustomAppState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const cart = cartState?.value;
    if (!cart) {
        return false;
    }
    const fulfillmentMethod = cart.fulfillmentMethod;
    const hasOutOfStockItems =
        fulfillmentMethod === FulfillmentMethod.PickUp
            ? cart.properties.hasOutOfStockItemsAtPickUp
            : cart.properties.hasOutOfStockItems;
    return parseBoolean(hasOutOfStockItems);
};
